export enum FatalErrorCategoryEnum {
  Content = 'content',
  SceneJS = 'scenejs'
}

export interface FatalErrorReportModel {
  title: string;
  description: string;
  canDownloadError?: boolean;
  url?: string;
}

export interface SceneJSFatalErrorModel {
  code: number;
  errorName: string;
  messageFromCaller: string;
  stackTrace: string;
}


